import axios from 'axios'

export default class GerenciamentoUsuarios {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/usuario/consulta`
    this.urlDownload = `${url}/api/usuario/exportar`
    this.urlPapeis = `${url}/api/usuario/papeis`
    this.tokenBearer = tokenBearer
  }

  async getUsuarios (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.url}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async downloadUsuarios (args = '') {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: `${this.urlDownload}?${args}`,
        headers: {
          'Authorization': this.tokenBearer
        },
        responseType: 'blob'
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  async getPapeis () {
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url: this.urlPapeis,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
